<template>
	<div class="team-fans-list">
		<!-- 筛选条件 -->
		<el-card class="filter-card" shadow="never">
			<div class="filter-content">
				<el-form :model="filterForm" :inline="true" class="filter-form">
					<!-- 时间筛选 -->
					<el-form-item label="时间范围：">
						<el-select v-model="filterForm.time" placeholder="选择时间范围" style="width: 150px" @change="handleSearch">
							<el-option label="默认" value="all"></el-option>
							<el-option label="今天" value="today"></el-option>
							<el-option label="昨天" value="yesterday"></el-option>
							<el-option label="近7天" value="seven"></el-option>
							<el-option label="近30天" value="thirty"></el-option>
							<el-option label="近3个月" value="thirtyMonth"></el-option>
							<el-option label="近6个月" value="sixMonth"></el-option>
							<el-option label="近1年" value="oneYear"></el-option>
						</el-select>
					</el-form-item>

					<!-- 用户维度 -->
					<el-form-item label="用户维度：">
						<el-select v-model="filterForm.user_type" placeholder="选择用户维度" style="width: 120px" @change="handleSearch">
							<el-option label="全部" value=""></el-option>
							<el-option label="有效" value="effective"></el-option>
							<!-- <el-option label="活跃" value="active"></el-option>
							<el-option label="新买家" value="new"></el-option> -->
						</el-select>
					</el-form-item>

					<!-- 成员等级 -->
					<el-form-item label="成员等级：">
						<el-select v-model="filterForm.fansLevel" placeholder="选择成员等级" style="width: 140px" @change="handleSearch">
							<el-option label="全部" value=""></el-option>
							<el-option label="直属成员" value="1"></el-option>
							<el-option label="二代成员" value="2"></el-option>
							<el-option label="二代以后" value="3"></el-option>
						</el-select>
					</el-form-item>

					<!-- 会员等级 -->
					<!-- <el-form-item label="会员等级：" v-if="teamLevels.length">
						<el-select v-model="filterForm.level" placeholder="选择会员等级" style="width: 150px" @change="handleSearch">
							<el-option label="全部" value=""></el-option>
							<el-option 
								v-for="level in teamLevels" 
								:key="level.level_key"
								:label="level.level_name" 
								:value="level.level_key"
							></el-option>
						</el-select>
					</el-form-item> -->

					<!-- 搜索条件 -->
					<el-form-item label="搜索：">
						<el-input 
							v-model="filterForm.search" 
							placeholder="手机号/昵称/邀请码" 
							style="width: 180px"
							@keyup.enter.native="handleSearch"
						></el-input>
					</el-form-item>

					<!-- 操作按钮 -->
					<el-form-item>
						<el-button @click="handleSearch" :loading="loading">
							<i class="el-icon-search"></i>
							搜索
						</el-button>
						<el-button @click="handleReset">
							<i class="el-icon-refresh"></i>
							重置
						</el-button>
					</el-form-item>
				</el-form>
			</div>
		</el-card>

		<!-- 数据表格 -->
		<el-card class="table-card" shadow="never">
			<div class="table-header">
				<div class="header-left">
					<span class="title">成员列表</span>
					<span class="total">共 {{ total }} 个成员</span>
				</div>
				<el-button icon="el-icon-plus" @click="handleAddMember" v-if="xid == 'b47f64'||xid=='ab8c37'">
					新增成员
				</el-button>
			</div>
			
			<el-table 
				:data="fansList" 
				v-loading="loading"
				style="width: 100%"
				:height="tableHeight"
				stripe
				border
			>
				<!-- <el-table-column prop="id" label="用户ID" width="80" align="center"></el-table-column> -->
				
				<el-table-column label="用户信息" fixed="left" width="280">
					<template slot-scope="scope">
						<div class="user-info">
							<img :src="scope.row.avatar||'https://h5.dhcc.wang/images/avatar.png'" alt="头像" class="avatar" />
							<div class="info">
								<div class="nickname">{{ scope.row.nickname }}</div>
								<div class="mobile">{{ scope.row.mobile }}</div>
							</div>
						</div>
					</template>
				</el-table-column>

				<el-table-column label="等级信息" width="180" align="center">
					<template slot-scope="scope">
						<div class="level-info">
							<el-tooltip class="item" effect="dark" :content="scope.row.level_name" placement="top-start">
								<img :src="scope.row.level_icon" alt="等级" class="level-icon" />
							</el-tooltip>
						</div>
					</template>
				</el-table-column>

				<el-table-column prop="invite_code" label="邀请码" width="180" align="center"></el-table-column>

				<el-table-column label="是否有效" width="120" align="center">
					<template slot-scope="scope">
						<el-tooltip content="有过手机号绑定、淘宝备案、下单、提现其中任一行为的用户" placement="top" v-if="scope.row.is_effective">
							<el-tag type="info'" size="small">有效</el-tag>
						</el-tooltip>
						<!-- <el-tag :type="scope.row.is_effective ? 'success' : 'info'" size="small">
							{{ scope.row.is_effective ? '有效' : '无效' }}
						</el-tag> -->
					</template>
				</el-table-column>

				<el-table-column prop="wechat_id" label="微信号" width="180" align="center"></el-table-column>
			<el-table-column prop="ext_remark" label="备注" width="180" align="center"></el-table-column>
				<el-table-column prop="order_num" label="订单数" width="180" align="center">
					<template slot-scope="scope">
						<span class="amount color1">{{ scope.row.order_num }}</span>
					</template>
				</el-table-column>

				<el-table-column prop="credit_total" label="累计佣金" width="180" align="center">
					<template slot-scope="scope">
						<span class="amount">¥{{ scope.row.credit_total }}</span>
					</template>
				</el-table-column>

				<el-table-column prop="fans" label="团队成员" width="140" align="center">
					<template slot-scope="scope">
						<span class="amount color1">{{ scope.row.fans }}</span>
					</template>
				</el-table-column>

				<el-table-column prop="fans" label="直属成员" width="140" align="center">
					<template slot-scope="scope">
						<span class="amount color1">{{ scope.row.fansLevel1 }}</span>
					</template>
				</el-table-column>

				<el-table-column label="注册时间" width="180" align="center">
					<template slot-scope="scope">
						<span>{{ formatTime(scope.row.jointime) }}</span>
					</template>
				</el-table-column>

				<el-table-column label="最近登录" width="180" align="center">
					<template slot-scope="scope">
						<span>{{ formatTime(scope.row.logintime) }}</span>
					</template>
				</el-table-column>

				<el-table-column label="操作" align="center" width="160" fixed="right">
					<template slot-scope="scope">
						<div class="flex justify-center">
							<el-button type="text" size="mini" @click="handleViewDetail(scope.row)">
								查看详情
							</el-button>
							<el-button v-if="xid=='b47f64'" type="text" size="mini" @click="handleGetLink(scope.row)" style="color:#F56C6C">
								专属商城
							</el-button>
						</div>
					</template>
				</el-table-column>
			</el-table>

			<!-- 分页 -->
			<div class="pagination-wrapper">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="pagination.page"
					:page-sizes="[10, 20, 50]"
					:page-size="pagination.pagesize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
				></el-pagination>
			</div>
		</el-card>

		<!-- 新增会员弹窗 -->
		<AddMemberDialog ref="addMemberDialog" @success="handleAddSuccess" />

		<!-- 详情抽屉 -->
		<el-drawer
			title="成员详情"
			:visible.sync="drawerVisible"
			:with-header="false"
			direction="rtl"
			size="1200px"
			:before-close="handleCloseDrawer"
		>
			<FansDetail 
				v-if="drawerVisible"
				:fan-info="currentFan"
				@close="handleCloseDrawer"
			/>
		</el-drawer>
		<!-- 分享链接弹窗（使用 ShareLinkDialog 组件） -->
		<ShareLinkDialog ref="shareLinkDialog"></ShareLinkDialog>
	</div>
</template>

<script>
import { getTeamFansList, getTeamFansIndex, kwebGetShareUrl } from '@/api/public'
import { formatTime } from '@/utils/timeTransfer'
import FansDetail from './FansDetail'
import AddMemberDialog from './AddMemberDialog'
import ShareLinkDialog from './ShareLinkDialog.vue'
export default {
	name: 'TeamFansList',
	components: {
		FansDetail,
		AddMemberDialog,
		ShareLinkDialog
	},
	data() {
		return {
			loading: false,
			fansList: [],
			total: 0,
			tableHeight: 800,
			
			// 筛选条件
			filterForm: {
				time: 'all',
				search: '',
				user_type: '',
				fansLevel: '',
				uid: '',
				level: ''
			},
			
			// 分页
			pagination: {
				page: 1,
				pagesize: 10
			},
			
			// 团队等级选项
			teamLevels: [],
			
			// 抽屉相关
			drawerVisible: false,
			currentFan: null,
			xid:window.xid
		}
	},
	mounted() {
		this.calculateTableHeight()
		window.addEventListener('resize', this.calculateTableHeight)
		this.fetchTeamLevels()
		this.fetchFansList()
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.calculateTableHeight)
	},
	methods: {
		// 获取团队等级选项
		async fetchTeamLevels() {
			try {
				const response = await getTeamFansIndex({})
				if (response && response.code === 1 && response.data.teamLevel) {
					this.teamLevels = response.data.teamLevel.filter(item => item.level_key !== 0)
				}
			} catch (error) {
				console.error('获取团队等级失败:', error)
			}
		},

		// 获取成员列表
		async fetchFansList() {
			this.loading = true
			try {
				const params = {
					...this.filterForm,
					page: this.pagination.page,
					pagesize: this.pagination.pagesize,
					pcweb: 1
				}
				
				const response = await getTeamFansList(params)
				if (response && response.code === 1) {
					this.fansList = response.data.list || []
					this.total = response.data.total || 0
				} else if (response && response.isAuthError) {
					return
				} else {
					this.$message.error(response.msg || '获取数据失败')
				}
			} catch (error) {
				if (error && error.isAuthError) return
				console.error('获取成员列表失败:', error)
				this.$message.error('获取数据失败，请重试')
			} finally {
				this.loading = false
			}
		},

		// 搜索
		handleSearch() {
			this.pagination.page = 1
			this.fetchFansList()
		},

		// 重置
		handleReset() {
			this.filterForm = {
				time: 'all',
				search: '',
				user_type: '',
				fansLevel: '',
				uid: '',
				level: ''
			}
			this.pagination.page = 1
			this.fetchFansList()
		},

		// 分页大小改变
		handleSizeChange(val) {
			this.pagination.pagesize = val
			this.pagination.page = 1
			this.fetchFansList()
		},

		// 当前页改变
		handleCurrentChange(val) {
			this.pagination.page = val
			this.fetchFansList()
		},

		// 计算表格高度
		calculateTableHeight() {
			const windowHeight = window.innerHeight
			this.tableHeight = windowHeight - 350
		},

		// 格式化时间
		formatTime(timestamp) {
			return formatTime(timestamp * 1000)
		},

		// 查看详情
		handleViewDetail(fan) {
			this.currentFan = fan
			this.drawerVisible = true
		},

		// 关闭抽屉
		handleCloseDrawer() {
			this.drawerVisible = false
			this.currentFan = null
		},

		// 打开新增会员弹窗
		handleAddMember() {
			this.$refs.addMemberDialog.open()
		},

		// 新增会员成功回调
		handleAddSuccess() {
			this.fetchFansList()
		},

		// 获取链接（通过接口获取分享链接）
		handleGetLink(row) {
			kwebGetShareUrl({
				path: `xid=${window.xid}#/pages/marketing/jd/index`,
				user_id: row.id
			}).then(res => {
				var shareUrl = res.data.short_url
				if (shareUrl) {
					this.$refs.shareLinkDialog.open(shareUrl)
				} else {
					this.$message.warning('未获取到分享链接')
				}
			})
		}
	}
}
</script>

<style lang="scss" scoped>


.filter-card {
	margin-bottom: 20px;
	
	.filter-content {
		.filter-form {
			::v-deep .el-form-item {
				margin-bottom: 0;
				margin-right: 20px;
			}
			
			::v-deep .el-form-item__label {
				font-weight: 500;
				color: #606266;
			}
		}
	}
}

.table-card {
	.table-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 16px;

		.header-left {
			display: flex;
			align-items: center;
			gap: 12px;
		}

		.title {
			font-size: 16px;
			font-weight: 600;
			color: #303133;
		}
		
		.total {
			color: #909399;
			font-size: 14px;
		}
	}
	
	::v-deep .el-table {
		.user-info {
			display: flex;
			align-items: center;
			
			.avatar {
				width: 40px;
				height: 40px;
				border-radius: 50%;
				margin-right: 10px;
				object-fit: cover;
			}
			
			.info {
				.nickname {
					font-size: 14px;
					font-weight: 500;
					color: #303133;
					margin-bottom: 2px;
				}
				
				.mobile {
					font-size: 12px;
					color: #909399;
				}
			}
		}
		
		.level-info {
			display: flex;
			align-items: center;
			justify-content: center;
			
			.level-icon {
				height: 26px;
				margin-right: 6px;
			}
			
			.level-name {
				font-size: 12px;
				color: #606266;
			}
		}
		
		.amount {
			color: #e2231a;
			font-size: 18px;
			font-family: 'customFont';
		}
		.color1 {
			color: #111111;
		}
	}
	
	.pagination-wrapper {
		display: flex;
		justify-content: center;
		margin-top: 20px;
	}
}

@media (max-width: 768px) {
	.filter-form {
		::v-deep .el-form-item {
			margin-right: 10px !important;
			margin-bottom: 10px !important;
		}
	}
}
</style>
